<template>
  <span class="ancestor-label" :class="{ 'visuallyhidden': !name, 'ancestor-label--no-colon': hideColon }">   
    <span v-html="formattedName"></span>
  </span>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    id: [String, Number],
    ordinal: Number,
    useDisplayName: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: '',
    }
  },
  computed: {
    utilityId() {
      return this.$store.getters.utilityId
    },
    formattedName() {
      let name = this.name
      name = name.replace('<br>', '')
      name = name.replace('<br/>', '')
      return name
    },
    hideColon() {
      if (this.ordinal === 2) {
        return true
      }
      return
    }
  },
  methods: {
    setName() {
      if (this.utilityId && this.id) {        
        axios.get('/pricing-calculator/facility-profiles/' + this.utilityId + '/profile/' + this.id)
          .then(response => {   
            if (this.useDisplayName && response.data.displayName) {
              this.name = response.data.displayName
            } else {
              this.name = response.data.name
            }
          })
      }
    }
  },
  created() {
    this.setName()
  }
}
</script>
